import { createSvgIcon } from "@mui/material";

export const FluxIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="currentColor" fillRule="evenodd">
    <title>Flux</title>
    <path d="M0 20.683L12.01 2.5 24 20.683h-2.233L12.009 5.878 3.471 18.806h12.122l1.239 1.877H0z"></path>
    <path d="M8.069 16.724l2.073-3.115 2.074 3.115H8.069zM18.24 20.683l-5.668-8.707h2.177l5.686 8.707h-2.196zM19.74 11.676l2.13-3.19 2.13 3.19h-4.26z"></path>
  </svg>,
  "FluxIcon",
);
